import { render, staticRenderFns } from "./SharedOwnershipYN.vue?vue&type=template&id=4ef88672"
import script from "./SharedOwnershipYN.vue?vue&type=script&lang=js"
export * from "./SharedOwnershipYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports